import React, { forwardRef } from 'react'
import { ReactionsList, ReactionSelector } from 'stream-chat-react'

export const customReactionOptions = [
  { Component: () => <>😄</>, type: 'happy', name: 'Happy' },
  { Component: () => <>😂</>, type: 'haha', name: 'Joy' },
  { Component: () => <>👍</>, type: 'like', name: 'Thumbs up' },
  { Component: () => <>❤️</>, type: 'love', name: 'Heart' },
  { Component: () => <>😔</>, type: 'sad', name: 'Sad' },
  { Component: () => <>😲</>, type: 'wow', name: 'Astonished' },
  { Component: () => <>💪</>, type: 'flex', name: 'Flexed biceps' },
]

export const allCustomReactionOptions = [
  ...customReactionOptions,
  { type: 'angry', Component: () => <>😠</>, name: 'Angry' },
]

// ReactionSelector component requires forwarded reference
export const CustomReactionSelector = forwardRef((props, ref) => (
  /* @ts-ignore */
  <ReactionSelector {...props} ref={ref} reactionOptions={customReactionOptions} />
))

export const CustomReactionsList = (props: any) => (
  <ReactionsList {...props} reactionOptions={allCustomReactionOptions} />
)
